export enum PaymentType {
  PAYPAL = 'PAYPAL',
  payflowCreditCard = 'payflowCreditCard'
}
